import React from "react";

function AboutPage() {
  return (
    <div className="home about">
      <div className="content">
        <h3 className="mt-4">Get to Know Us</h3>
        <hr />
        <p>
          We are not the government we are a 3rd party company here to help
          people with the application process. We come from a background of
          business experts who wanted to be able to help other people start
          their businesses. And we know the first step to starting your business
          is to become a legitimate business in the eyes of the government.
        </p>
        <p>
          We started the service to make the process of beginning your journey
          into the entrepreneurial world a little easier. With all of the
          options and possibilities to make a mistake and deter you from
          starting your business before you’ve even helped your first customer,
          we wanted to make sure that doesn’t happen.
        </p>
        <p>
          Many of the people who work here have a background in business
          consulting in this business was started because we saw a need with
          helping new businesses to get established properly and then set up for
          success and profitability.
        </p>
      </div>
    </div>
  );
}

export default AboutPage;
